import { collections, collectionStats } from "@/mocks/homeFeed";

export default function CollectionIndex() {
  return (
    <section id="collections" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-3">
              <span className="w-7 h-7 rounded-md bg-background-50 text-foreground-950 text-xs font-label font-medium flex items-center justify-center">
                02
              </span>
              <span className="text-xs font-label tracking-[0.25em] text-primary-300 uppercase">
                Collection Index
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 leading-snug">
              合集索引：按线索归档，比翻时间线更快
            </h2>
            <p className="mt-4 text-sm md:text-base text-background-50/70 leading-relaxed">
              同一件事往往散在很多帖子里。我们把它们收进合集，辟谣的归辟谣、出现反转的单独成册，想看真假变化随时点进对应索引，不用从头刷起。
            </p>

            <div className="mt-8 space-y-3">
              {collectionStats.map((stat) => (
                <div
                  key={stat.label}
                  className="flex items-baseline gap-3 border-l-2 border-background-50/25 pl-4"
                >
                  <span className="font-heading text-2xl font-bold text-primary-300">
                    {stat.value}
                  </span>
                  <span className="text-sm font-label text-background-50/70">
                    {stat.label}
                  </span>
                </div>
              ))}
            </div>

            <a
              href="#reversals"
              className="mt-8 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-label transition-colors whitespace-nowrap cursor-pointer"
            >
              进入合集总览
              <i className="ri-arrow-right-line text-base w-4 h-4 flex items-center justify-center" />
            </a>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {collections.map((col, idx) => (
                <a
                  key={col.id}
                  href="#reversals"
                  className="group rounded-lg overflow-hidden bg-background-50/5 border border-background-50/15 hover:border-primary-400/60 transition-colors cursor-pointer"
                >
                  <div className="relative w-full h-40">
                    <img
                      src={col.cover}
                      alt={`${col.name}封面`}
                      title={`${col.name} 蝌蚪黑料合集索引`}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/75 via-foreground-950/15 to-transparent" />
                    <span className="absolute top-3 left-3 text-[11px] font-label px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 whitespace-nowrap">
                      {col.tag}
                    </span>
                    <span className="absolute top-3 right-3 font-heading text-xs font-bold text-background-50/70">
                      No.{String(idx + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-base font-semibold text-background-50 group-hover:text-primary-300 transition-colors">
                      {col.name}
                    </h3>
                    <div className="mt-3 flex items-center justify-between text-xs font-label text-background-50/60">
                      <span>收录 {col.count} 条</span>
                      <span>{col.update}</span>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}